import { useContext, useState } from "react";
import {
  CustomModal,
  getFileIcon,
  toStandardDate,
} from "../../../../utils/UtilFunctions";
import Delete1 from "../../../../images/DeleteButton.svg";
import Update from "../../../../images/Edit.svg";
import View from "../../../../images/Eye.svg";
import {
  AddCaseStudyStyles,
  ViewModalStyles,
  ViewMoreFileStyles,
} from "../../../../styles/CustomModalStyles";
import { Title } from "../../../../stories/Title/Title";

import Close from "../../../../images/Close.svg";
import { Button } from "../../../../stories/Button/Button";
import ViewCaseStudyDetails from "./ViewDetails";
import Add from "./Add";
import { Operation, empType } from "../../../../utils/Enum.types";
import DeleteModal from "../../../../customComponents/DeleteModal";
import {
  CaseStudiesOrderField,
  CaseStudyNode,
  DeleteCaseStudyData,
  DeleteCaseStudyVar,
} from "./queries/types";
import { DeleteCaseStudy } from "./queries/mutations";
import { useMutation } from "@apollo/client";
import useLoggedInUserDetails from "../../../../customHooks/useLoggedInUserDetails";
import { GetCaseStudies } from "./queries/query";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import {
  EMPTY_STRING,
  emptyMessage,
  TEN_ROWS,
} from "../../../../utils/constants";
import useUrlParams from "../../../../customHooks/useUrlParams";
import { msgType } from "../../../../utils/types";
import MessageModal from "../../../../customComponents/MessageModal";
import LoadingModal from "../../../pages/LoadingModal";
import { getDownloadUrl } from "../../../../utils/DownloadFile";
import { AppContext } from "../../../../context/context";

interface Props {
  res: CaseStudyNode;
  index: number;
}

const List = ({ res, index }: Props) => {
  const [moreFiles, setMoreFiles] = useState(false);
  const { customer_id } = useUrlParams();

  const [viewDetails, setViewDetails] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState(0);
  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [attachments, setAttachments] = useState<string[]>([]);
  const { state } = useContext(AppContext);

  const [Delete, { loading }] = useMutation<
    DeleteCaseStudyData,
    DeleteCaseStudyVar
  >(DeleteCaseStudy);

  const handleDelete = (id: number) => {
    setDeleteModal(!deleteModal);
    Delete({
      variables: {
        caseStudyID: id,
        user_details,
      },
      refetchQueries: [
        {
          query: GetCaseStudies,
          variables: {
            after: null,
            first: TEN_ROWS,
            orderBy: {
              direction: OrderDirection.ASC,
              field: CaseStudiesOrderField.CREATED_AT,
            },
            name: EMPTY_STRING,
            customerID: customer_id,
          },
        },
      ],
    }).then(({ data }) => {
      if (data && data.DeleteCaseStudy) {
        setMessage({
          flag: true,
          message: "Deleted case study",
          operation: Operation.CREATE,
        });
      }
    });
  };

  return (
    <>
      <div className="case-study-list">
        <div>
          <b className="case-study-list--project-name">
            {index + 1}. {res.title} {res.caseType ? <>({res.caseType})</>:null}
          </b>
          <div className="case-study-list--flex">
            <b className="font-green">{toStandardDate(res.startDate)}-</b>
            <b className="font-red">{toStandardDate(res.endDate)}</b>
          </div>
          {res.documents.length ? (
            <div className="case-study-list--flex">
              {res.documents
                .split(";")
                .slice(0, 2)
                .map((file,index) => {
                  const filename = file.split("/").pop();
                  return (
                    <div
                      className="case-study-list--attachments"
                      key={file}
                      onClick={() => {
                        const ext = filename?.split(".").pop();
                        const modifiedFileName = `${customer_id}/caseStudies/${res.id}_${index}.${ext}`;                    
                        getDownloadUrl(modifiedFileName, true);
                      }}
                    >
                      <img src={getFileIcon(file)} alt="" />
                      <span>{filename}</span>
                    </div>
                  );
                })}
              {res.documents.split(";").length > 2 && (
                <>
                  <button
                    className="case-study-list--more"
                    onClick={() => {
                      setAttachments(res.documents.split(";"));
                      setMoreFiles(!moreFiles);
                    }}
                  >
                    +{res.documents.split(";").length - 2} more ...
                  </button>

                  <CustomModal
                    style={ViewMoreFileStyles}
                    isOpen={moreFiles}
                    onRequestClose={() => setMoreFiles(!moreFiles)}
                    contentComponent={
                      <div className="case-study-list--more-files">
                        <div className="case-study-list--more-files-t">
                          <Title>Uploaded Files</Title>
                          <img
                            src={Close}
                            alt=""
                            onClick={() => setMoreFiles(!moreFiles)}
                          />
                        </div>
                        <div className="case-study-list--more-files--block">
                          {attachments.map((files, index) => {
                            const filename = files.split("/").pop();

                            return (
                              <div
                                className="case-study-list--attachments"
                                key={index}
                                onClick={() => {
                                  const ext = filename?.split(".").pop();
                                  const modifiedFileName = `${customer_id}/caseStudies/${res.id}_${index}.${ext}`;
                                  getDownloadUrl(modifiedFileName, true);
                                }}
                              >
                                <img src={getFileIcon(files)} alt="" />
                                <span> {filename}</span>
                              </div>
                            );
                          })}
                        </div>
                        <Button
                          mode="cancel"
                          onClick={() => setMoreFiles(!moreFiles)}
                        />
                      </div>
                    }
                  />
                </>
              )}
            </div>
          ) : null}
        </div>
        {state.empSubType === empType.PMU ? (
          <div className="case-study-list--flex">
            <button
              className="case-study-list--view"
              onClick={() => {
                setDeletedId(res.id);
                setViewDetails(!viewDetails);
              }}
              disabled={loading}
            >
              View Details <img src={View} alt="" />
            </button>
            <button
              className="case-study-list--update"
              onClick={() => {
                setDeletedId(res.id);
                setUpdate(!update);
              }}
              disabled={loading}
            >
              Update <img src={Update} alt="" />
            </button>
            <button
              className="case-study-list--delete"
              onClick={() => {
                setDeletedId(res.id);
                setDeleteModal(!deleteModal);
              }}
              disabled={loading}
            >
              Delete <img src={Delete1} alt="" />
            </button>
          </div>
        ) : null}
      </div>

      <CustomModal
        style={ViewModalStyles}
        isOpen={viewDetails}
        onRequestClose={() => setViewDetails(!viewDetails)}
        contentComponent={
          <ViewCaseStudyDetails
            setModal={setViewDetails}
            caseStudyID={deletedId}
          />
        }
      />
      <CustomModal
        style={AddCaseStudyStyles}
        isOpen={update}
        onRequestClose={() => setUpdate(!update)}
        contentComponent={
          <Add
            setModal={setUpdate}
            caseStudyID={deletedId}
            operation={Operation.UPDATE}
          />
        }
      />
      <DeleteModal
        id={deletedId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />
      <MessageModal
        handleClose={() => {
          setDeletedId(0);
          setMessage(emptyMessage);
        }}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <LoadingModal flag={loading} />
    </>
  );
};

export default List;
